// The guide registry: the GuideId union and the tables derived from it. Kept in one file so a
// new guide cannot be added to the union without the tables noticing.

// ── Guide IDs ─────────────────────────────────────────────────────────────────

export type GuideId = 'cli-getting-started' | 'cli-auth' | 'cli-commands' | 'cli-ci' | 'storing-state' | 'module-packaging' | 'module-publishing' | 'module-consumption' | 'using-providers' | 'lock-files' | 'passive-drift' | 'oidc-trust' | 'policy-modules' | 'policy-state' | 'policy-providers' | 'troubleshooting'

export const GUIDES: { id: GuideId; label: string }[] = [
  { id: 'cli-getting-started', label: 'Getting Started' },
  { id: 'cli-auth',          label: 'Signing In' },
  { id: 'cli-commands',      label: 'Commands' },
  { id: 'cli-ci',            label: 'Using in CI' },
  { id: 'module-packaging',  label: 'Packaging' },
  { id: 'module-publishing', label: 'Publishing' },
  { id: 'module-consumption', label: 'Consuming' },
  { id: 'using-providers',   label: 'Consuming' },
  { id: 'lock-files',        label: 'Provider Lock Files' },
  { id: 'storing-state',     label: 'Publishing' },
  { id: 'passive-drift',     label: 'Passive Drift Detection' },
  { id: 'oidc-trust',        label: 'Pipeline Trust' },
  { id: 'policy-modules',    label: 'Module' },
  { id: 'policy-state',      label: 'State' },
  { id: 'policy-providers',  label: 'Provider' },
  { id: 'troubleshooting',   label: 'Troubleshooting' },
]

export const GUIDE_LABEL = Object.fromEntries(GUIDES.map((g) => [g.id, g.label])) as Record<GuideId, string>

// ── Categories (sidebar grouping) ─────────────────────────────────────────────
// Guides are grouped by topic in the sub-nav; guide IDs are unchanged so
// existing /integrations/:guide deep links keep working. `passive-drift` and
// `lock-files` are deliberately absent from every category - they stay
// reachable by deep link only.

export const CATEGORIES: { label: string; guides: GuideId[]; soon?: string[] }[] = [
  { label: 'Terramantle CLI', guides: ['cli-getting-started', 'cli-auth', 'cli-commands', 'cli-ci'] },
  { label: 'Modules',   guides: ['module-packaging', 'module-publishing', 'module-consumption'] },
  { label: 'Providers', guides: ['using-providers'] },
  { label: 'State',     guides: ['storing-state'] },
  { label: 'Pipelines', guides: ['oidc-trust'] },
  { label: 'Policy Schemas',  guides: ['policy-modules', 'policy-state', 'policy-providers'] },
  { label: 'Help',      guides: ['troubleshooting'] },
]
